import React from "react";

const HeroValuesMobile = () => {
  return (
    <>
      {/* // Mobile Version */}
      <div className="w-full py-8 relative bg-[#F4F4F4] md:hidden block">
        <div className="mx-auto text-[#071B30] z-50 relative">
          {/* Heading */}
          <div className="flex justify-center">
            <h2 className="font-bold text-[24px] leading-normal tracking-[-0.96px] text-center mb-6 inline-block border-b-[4px] border-[#FFA548]">
              <span className="text-[#3174d6]">H </span>
              <span className="text-[#BD132D]">E </span>
              <span className="text-[#FFBA08]">R </span>
              <span className="text-[#008D82]">O </span>
              <span className="text-[#071B30] text-[24px] font-semibold tracking-[-0.96px] leading-normal">
                {" "}
                Values
              </span>
            </h2>
          </div>
          {/* Card Section */}
          <div className="flex flex-col gap-4 justify-center items-center">
            {/* Hustle & Hard Work Card */}
            <div className="relative flex flex-col bg-white rounded-[12px] shadow-md p-4 w-[328px] h-[212px]">
              <div className="absolute top-0  left-[13%] transform -translate-x-1/2 flex items-center justify-center">
                <img
                  src="/about-us/h1.png"
                  alt="Hustle & Hard Work"
                  className="w-[90px] h-[80px] rounded-tl-[12px]"
                />
              </div>
              <h2 className="text-[20px] leading-[126%] font-bold text-gray-900 mt-[26%] mb-2 ">
                Hustle & Hard Work
              </h2>
              <p className="text-[#5C5C5C] text-[14px] leading-[126%] tracking-[-0.56px] font-normal ">
                We embrace relentless dedication to our mission, always going
                the extra mile. This hustle culture is about putting our heart
                into what we do.
              </p>
            </div>

            {/* Emotional Intelligence Card */}
            <div className="relative flex flex-col bg-white rounded-[12px] shadow-md p-4 w-[328px] h-[212px]">
              <div className="absolute top-0  left-[13%] transform -translate-x-1/2 flex items-center justify-center">
                <img
                  src="/about-us/h2.png"
                  alt="Emotional Intelligence"
                  className="w-[90px] h-[80px] rounded-tl-[12px]"
                />
              </div>
              <h2 className="text-[20px] leading-[126%] font-bold text-gray-900 mt-[26%] mb-2 ">
                Emotional Intelligence
              </h2>
              <p className="text-[#5C5C5C] text-[14px] leading-[126%] tracking-[-0.56px] font-normal ">
                We prioritize emotional intelligence, fostering a collaborative
                team culture and enhancing relationships with clients and
                stakeholders.
              </p>
            </div>

            {/* Resilience to Change Card */}
            <div className="relative flex flex-col bg-white rounded-[12px] shadow-md p-4 w-[328px] h-[212px]">
              <div className="absolute top-0  left-[13%] transform -translate-x-1/2 flex items-center justify-center">
                <img
                  src="/about-us/h3.png"
                  alt="Resilience to Change"
                  className="w-[90px] h-[80px] rounded-tl-[12px]"
                />
              </div>
              <h2 className="text-[20px] leading-[126%] font-bold text-gray-900 mt-[26%] mb-2">
                Resilience to Change
              </h2>
              <p className="text-[#5C5C5C] text-[14px] leading-[126%] tracking-[-0.56px] font-normal ">
                Change is constant, and we thrive by adapting swiftly,
                integrating AI and technology to transform challenges into
                opportunities.
              </p>
            </div>

            {/* Ownership Mindset Card */}
            <div className="relative flex flex-col bg-white rounded-[12px] shadow-md p-4 w-[328px] h-[212px]">
              <div className="absolute top-0  left-[13%] transform -translate-x-1/2 flex items-center justify-center">
                <img
                  src="/about-us/h4.png"
                  alt="Ownership Mindset"
                  className="w-[90px] h-[80px] rounded-tl-[12px]"
                />
              </div>
              <h2 className="text-[20px] leading-[126%] font-bold text-gray-900 mt-[26%] mb-2 ">
                Ownership Mindset
              </h2>
              <p className="text-[#5C5C5C] text-[14px] leading-[126%] tracking-[-0.56px] font-normal ">
                We think and act like owners, taking accountability for
                outcomes. Our commitment is reflected in our drive to lead,
                excel, and serve.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroValuesMobile;
